import { createHashRouter } from "react-router-dom";
import Landing from "./screens/Landing";
import { GetInTouch } from "./screens/AsheriTechComponents/GetInTouch/GetInTouch";
import { RegistrationForm } from "./screens/AsheriTechComponents/RegistrationForm/RegistrationForm";
import Teams from "./screens/Teams/Teams";
import Services from "./screens/BookaRoom/BookaRoom";
import Aboutus from "./screens/WhatWeDo/WhatWeDo";
import AboutTheCompany from "./screens/AboutTheCompany/AboutTheCompany";
import CommingSoon from "./components/Sections/CommingSoonPage/CommingSoon";
import SingleCourse from "./screens/SingleCourseScreen/SingleCourse";
import Career from "./screens/CorporateTrainings/CorporateTrainings";
import CorporateTrainingSingle from "./screens/CorporateTrainingSingle/CorporateTrainingSingle";
import CorporateSocialResponsibility from "./screens/CorporateSocialResponsibility/CorporateSocialResponsibility";
import NewComingSoon from "./components/Sections/CommingSoonPage/NewCommingSoon";
import Chart from "./components/Sections/CommingSoonPage/Chart";
import FindTechTalent from "./screens/FindTechTalent/FindTechTalent";
import Blog from "./screens/Blog/Blog";
import Jobs from "./screens/Jobs/jobs";
import ContactUsForm from "./screens/Contactus/contact";
import WhatWeDo from "./screens/WhatWeDo/WhatWeDo";
import ServicesDetails from "./screens/ServicesDetails/ServicesDetails";
import JobListing from "./screens/Jobs/JobListing/JobListing";



export const router = createHashRouter([
    {
      path: "/",
      element:  <Landing />,
    },  
    {
      path: "/Contact",
      element:  <ContactUsForm />,
    },  
    {
      path: "/jobs",
      element:  <Jobs/>,
    },  
    // {
    //   path: "/CommingSoon",
    //   element:  <CommingSoon />,
    // }, 
    {
      path: "/CommingSoon",
      element:  <NewComingSoon />,
    },  
    {
      path: "/GetInTouch",
      element: <GetInTouch />,
    },
    {
      path: "/RegistrationForm",
      element: <RegistrationForm />,
    },
    {
      path: "/teams",
      element: <Teams/>,
    },
    {
      path: "/Services",
      element: <Services />,
    },
    {
      path: "/Aboutus",
      element: <Aboutus/>,
    },
    {
      path: "/aboutthecompany",
      element: <AboutTheCompany/>,
    },
    {
      path: "/CommingSoonPage",
      element: <CommingSoon/>,
    },
    {
      path: "/courses",
      element: <SingleCourse/>,
    },
    {
      path: "/Career",
      element: <Career/>,
    },
    {
      path: "/CorporateTrainingSingle",
      element: <CorporateTrainingSingle/>,
    },
    {
      path: "/CorporateSocialResponsibility",
      element: <CorporateSocialResponsibility/>,
    },
    {
      path: "/chart",
      element: <Chart/>,
    },
    {
      path: "/findtechtalent",
      element: <FindTechTalent/>,
    },
    {
      path: "/blog",
      element: <Blog/>,
    },
    {
      path: "/Services/whatWeDo",
      element: <ServicesDetails />,
    },
    {
      path: "/JobListing",
      element: <JobListing />,
    },
  ]);